import React, { FunctionComponent, useRef, useState, useEffect } from "react";
import {
  Typography,
  Container,
  Grid,
  makeStyles,
  MenuItem,
  Paper,
} from '@material-ui/core';
import SteveJobsImages from "../../Assets/Images/steveJobs.jpg";
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import { autoFacebookCreateApi, autoWhatsAppCreateApi, createOrganization, fetchNews, updateWhatsAppConfig } from "../../Services/organizations";
import axios from "axios";
import { url } from "../../Values/constants"
import { createAutoFAQ, createAutoNews, createBudgetAuto, createCurouseAuto, createLeadSourceAuto, createLocationAuto, createPropertyStageAuto, createPropertySubTYpeAuto, createPropertyTypesAuto, createTrasferReasonsAuto, fetchFAQAdmin, fetchLicensesCost, fetchResources } from "../../Services/resources";
import BusinessIcon from '@mui/icons-material/Business';
import { Circles, Audio, BallTriangle } from 'react-loader-spinner';
import Avatar from '@material-ui/core/Avatar';
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import './RegistrationFormGridOverride.css';

const useStyles = makeStyles((theme) => ({
  outercontainer: {
    minHeight: '100vh',
    background: '#fff',
    padding: 0,
    margin: 0,
  },
  root: {
    minHeight: '100vh',
    padding: 0,
    margin: 0,
    maxWidth: '100vw',
    background: "linear-gradient(135deg, rgb(255,250,250) 0%, #e0e7ff 100%)",
  },
  formContainer: {
    padding: theme.spacing(3, 4),
    borderRadius: 24,
    background: '#fff',
    boxShadow: '0 8px 32px rgba(44, 62, 80, 0.10)',
    margin: 'auto',
    marginTop: 15,
    maxWidth: 520,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),
      maxWidth: '100%',
    },
  },
  logoimage: {
    width: 170,
    marginBottom: 8,
  },
  signupButton: {
    backgroundColor: '#111627',
    color: '#fff',
    borderRadius: 12,
    fontWeight: 700,
    fontSize: 18,
    padding: '16px 0',
    marginTop: theme.spacing(2),
    letterSpacing: 1,
    boxShadow: '0 2px 8px rgba(44, 62, 80, 0.10)',
    '&:hover': {
      backgroundColor: '#23263a',
    },
  },
  alreadyAccount: {
    marginTop: theme.spacing(3),
    textAlign: 'center',
    fontSize: 16,
    color: '#222',
    fontWeight: 400,
    '& span': {
      fontWeight: 700,
      cursor: 'pointer',
      color: '#15192c',
      marginLeft: 4,
    },
  },
  testimonialSection: {
    background: '#0c1222',
    color: '#fff',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '0 64px',
    [theme.breakpoints.down('sm')]: {
      minHeight: 320,
      padding: '32px 12px',
      alignItems: 'center',
    }

  },
  quoteIcon: {
    background: '#23263a',
    borderRadius: 16,
    width: 64,
    height: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
  },
  quoteText: {
    fontSize: "var(--font-size-large)",
    fontFamily: "var(--font-family-main)",
    lineHeight: 1.35,
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(2),
    color: '#fff',
    maxWidth: 420,
  },
  testimonialUser: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(4),
  },
  testimonialAvatar: {
    width: 54,
    height: 54,
    marginRight: theme.spacing(2),
  },
  testimonialName: {
    fontWeight: 700,
    fontSize: 19,
    color: '#fff',
  },
  testimonialRole: {
    fontSize: 15,
    color: '#bfc7d5',
    fontWeight: 400,
  },
}));

const primaryColor = "#292744";

// 🔹 Custom styled TextField
const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    backgroundColor: "#f7f8fa",
    fontSize: "var(--font-size-large)",
    fontFamily: "var(--font-family-main)",
    "& fieldset": {
      borderColor: "#bfc7d5",
    },
    "&:hover fieldset": {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`
    },
    "&.Mui-focused fieldset": {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`
    },
  },
  "& .MuiInputBase-input": {
    padding: "14px",
    fontSize: 16,
    color: "#222",
  },
  "& .MuiInputLabel-root": {
    fontWeight: 500,
    fontSize: 15,
    color: primaryColor,
  },
});

// 🔹 Wrapper for PhoneInput to match style
const PhoneInputWrapper = styled("div")({
  position: 'relative',
  '& .form-control': {
    width: "100% !important",
    borderRadius: 12,
    backgroundColor: "#f9fafb",
    fontSize: "var(--font-size-large)",
    fontFamily: "var(--font-family-main)",
    color: "#222",
    boxSizing: 'border-box',
    height: '48px',
    lineHeight: '48px',
    padding: '0 14px 0 48px',
    border: '1.5px solid #bfc7d5',
    transition: 'border 0.2s',
  },
  '& .form-control:focus': {
    border: `1.5px solid ${primaryColor}`,
    boxShadow: "none",
  },
  '& .special-label': {
    display: 'none',
  },
});

const CustomFormControl = styled(FormControl)({
  minWidth: '100%',
  '& .MuiInputLabel-root': {
    color: primaryColor,
    fontWeight: 500,
    fontSize: 15,
    background: '#f7f8fa',
    padding: '0 4px',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    backgroundColor: '#f7f8fa',
    '& fieldset': {
      borderColor: '#bfc7d5',
    },
    '&:hover fieldset': {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`
    },
    '&.Mui-focused fieldset': {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`
    },
  },
  '& .MuiSelect-select': {
    padding: '14px',
    fontSize: 16,
    color: '#222',
    borderRadius: 12,
    backgroundColor: '#f7f8fa',
  },
});

type props = {
  history: any;
};
const RegistrationForm: FunctionComponent<props> = ({ history }) => {
  const dispatcher = useDispatch();
  const classes = useStyles();
  const [formData, setFormData] = useState({
    orgAddress: '',
    numberOfEmployees: '',
    organizationName: '',
    email: '',
    mobileNumber: '',
    pincode: '',
    adminEmail: '',
    adminFirstName: '',
    adminLastName: ''
  });
  const [phoneCountryCode, setPhoneCountryCode] = useState('in');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [finalPhoneNumber, setFinalPhoneNumber] = useState('');
  const [adminPhoneCountryCode, setAdminPhoneCountryCode] = useState('in');
  const [adminPhoneNumber, setAdminPhoneNumber] = useState('');
  const [adminFinalPhoneNumber, setAdminFinalPhoneNumber] = useState('');
  const [countryList, setCountryList] = useState([]);
  const [country, setCountry] = useState<object>({});
  const [statesList, setStatesList] = useState([]);
  const [state, setState] = useState<object>({});
  const [citiesList, setCitiesList] = useState([]);
  const [cities, setCities] = useState<object>({});
  const [load, setLoad] = useState(false);
  const [booleanSendEmail, setBooleanSendEmail] = useState(false);
  const [pwd, setPwd] = useState("");
  const [industry, setIndustry] = useState<object>({});
  const [orgId, setOrgId] = useState();
  const [authId, setAuthId] = useState();
  const [cost, setCost] = useState<any>("");
  const [industryList, setIndustryList] = useState([]);
  const [noEmp, setNoEmp] = useState<any>("");
  const [costLicensesData, setCostLicensesData] = useState<any[] | undefined>(undefined);
  const [faqList, setfaqList] = useState<any[] | undefined>(undefined);
  const [news, setNews] = useState<any[] | undefined>(undefined);
  const [comTypes, setComTypes] = useState<any[]>([]);
  const [resTypes, setResTypes] = useState<any[]>([]);
  const [transferReasons, setTransferReasons] = useState<any[]>([]);
  const [propertyTypes, setPropertyTypes] = useState<any[]>([]);
  const [propertyStage, setPropertyStage] = useState<any[]>([]);
  const [propertySubType, setPropertySubType] = useState<any[]>([]);
  const [leadSourceList, setLeadSourceList] = useState<any[]>([]);
  const [budgetsList, setBudgetsList] = useState<any[]>([]);
  const [locationsList, setLocationsList] = useState<any[]>([]);
  const [carouselList, setCarouselList] = useState<any[] | undefined>(
    undefined
  );

  useEffect(() => {
    const unsub = fetchResources(
      (data) => setLocationsList(data),
      (data) => setBudgetsList(data),
      (data) => setCarouselList(data),
      (data) => setLeadSourceList(data),
      (data) => setComTypes(data),
      (data) => setResTypes(data),
      " ",
      (data) => setTransferReasons(data),
      (data) => setPropertyTypes(data),
      (data) => setPropertyStage(data),
      (data) => setPropertySubType(data),
    );
    return () => {
      unsub();
    };
  }, []);
  useEffect(() => {
    fetchNews(" ", (val) => setNews(val));
  }, [])
  useEffect(() => {
    fetchFAQAdmin((data) => setfaqList(data));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countryRes = await axios.post(
          `${url}/country/countries`);
        // handle response
        setCountryList(countryRes.data);
      } catch (error) {
        // handle error
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (Object.keys(country).length !== 0) {
      const fetchData = async () => {
        try {
          const statesRes = await axios.post(
            `${url}/country/states`, { iso3: (country as any).value });
          // handle response
          setStatesList(statesRes.data);
        } catch (error) {
          // handle error
        }
      };
      fetchData();

    }
  }, [country]);

  useEffect(() => {
    if (Object.keys(country).length !== 0 && Object.keys(state).length !== 0) {
      const fetchData = async () => {
        try {
          const citiesRes = await axios.post(
            `${url}/country/cities`, { iso3: (country as any).value, state_code: (state as any).value });
          // handle response
          setCitiesList(citiesRes.data);
        } catch (error) {
          // handle error
        }
      };
      fetchData();
    }
  }, [country, state])

  useEffect(() => {
    if (booleanSendEmail) {
      sendResetPasswordEmail();
      createOrganizationDb();
      autoFacebookCreateApi(
        orgId,
        "Facebook",
        // (country as any).value,
        adminPhoneCountryCode == "in" ? "+91" : `+${adminPhoneCountryCode}`,
        formData.adminEmail.toLowerCase(),
        adminPhoneCountryCode == "in" ? 91 : parseInt(adminPhoneCountryCode),
        adminFinalPhoneNumber,
        formData.adminFirstName,
        formData.adminLastName,
      );

      autoWhatsAppCreateApi(
        orgId,
        formData.adminEmail.toLowerCase(),
        adminPhoneCountryCode == "in" ? 91 : parseInt(adminPhoneCountryCode),
        adminFinalPhoneNumber,
        formData.adminFirstName,
        formData.adminLastName,
      );
      createResources();
      createWhatsAppConfig();
    }
  }, [booleanSendEmail]);

  useEffect(() => {
    setCost(costLicensesData?.[0]?.licensesCost);
    setNoEmp(costLicensesData?.[0]?.no_employees);
  }, [costLicensesData]);

  useEffect(() => {
    fetchLicensesCost((data) => setCostLicensesData(data));
  }, [])

  const createWhatsAppConfig = () => {

    const incomingMessage = {
      "Customer Name": "customer_name",
      "Contact Number": "contact_no",
      "Alternate Number": "alternate_no",
      "Country Code": "country_code",
      "Lead Type": "lead_type",
      "Email": "email",
      "Lead Source": "lead_source",
      "Organization Name": "organization_name",
      "Message": "Please check your leads in CRM on daily basis, As WhatsApp notifications gets\n\nfail sometimes due to network connections.\n\nDo not rely on WhatsApp notifications."
    }

    const transferMessage = {
      "Customer Name": "customer_name",
      "Contact Number": "contact_no",
      "Alternate Number": "alternate_no",
      "Country Code": "country_code",
      "Lead Type": "lead_type",
      "Email": "email",
      "Lead Source": "lead_source",
      "Organization Name": "organization_name",
      "Message": "Please check your leads in CRM on daily basis, As WhatsApp notifications gets\n\nfail sometimes due to network connections.\n\nDo not rely on WhatsApp notifications."
    }

    const simplyId = crypto.randomUUID();
    const wapiId = crypto.randomUUID();

    const payload = {
      simply: {
        id: simplyId,
        type: "Simply WhatsApp",
        instance_id: "66FA5B*******",
        access_token: "655cebdf******",
        url: "https://app.simplywhatsapp.com***********",
        incoming_json:JSON.stringify(incomingMessage),
        transfer_json: JSON.stringify(transferMessage),
        active: true,
      },
      wapi: {
        id: wapiId,
        wapi_url: "https://gate.whapi.*********",
        wapi_token: "OV27q3a1QL7Kv1YizZisCHM*********",
        type: "WAPI",
        active: false,
        incoming_json: JSON.stringify(incomingMessage),
        transfer_json: JSON.stringify(transferMessage),
      }
    };

    try {
      updateWhatsAppConfig(orgId, payload);
    } catch (err) {
      console.log(err);
    }
  }

  const createResources = () => {
    createLocationAuto(
      orgId,
      locationsList
    )
    createBudgetAuto(
      orgId,
      budgetsList
    )
    createCurouseAuto(
      orgId,
      carouselList
    )
    createLeadSourceAuto(
      orgId,
      leadSourceList
    )
    createPropertyStageAuto(
      orgId,
      propertyStage
    )
    createPropertyTypesAuto(
      orgId,
      propertyTypes
    )
    createPropertySubTYpeAuto(
      orgId,
      propertySubType
    )
    createTrasferReasonsAuto(
      orgId,
      transferReasons
    )
  }
  const createOrganizationDb = async () => {
    const bodyData = {
      organization_id: orgId,
      address: formData.orgAddress,
      admin_contact_number: adminFinalPhoneNumber,
      admin_email_id: formData.adminEmail.toLowerCase(),
      admin_first_name: formData.adminFirstName,
      admin_last_name: formData.adminLastName,
      auth_id: authId,
      city: (cities as any).label,
      country: (country as any).label,
      created_at: "",
      designations: [],
      email_id: formData.email.toLowerCase(),
      mobile_number: finalPhoneNumber,
      no_of_employees: formData.numberOfEmployees,
      organization_name: formData.organizationName,
      state: (state as any).label,
      status: "ACTIVE",
      teams: [],
      industry_id: (industry as any).value,
      payment_status: true,
      grace_period: 7,
      showData: true,
      trial_period: true,
      cost_per_license: cost,
      org_trial_period_users_licenses: noEmp,
    }
    const createOrg = await axios.post(
      url + '/organizations/create', bodyData
    );
  }

  const sendResetPasswordEmail = async () => {
    let email = formData.adminEmail.toLowerCase()
    let firstName = formData.adminFirstName;
    let lastName = formData.adminLastName;
    if (email !== "") {
      try {
        if (email) {
          setLoad(true);
          const resetPasswordEmailApiData = {
            "template_name": "Password_Reset_Notification",
            "replaceable_params": [
              { "%#username#%": `${firstName} ${lastName}` },
              { "%#password#%": pwd }
            ],
            "email": email
          }
          await axios.post(
            url + '/email/sendEmail',
            resetPasswordEmailApiData
          );
          setLoad(false);
          dispatcher(
            showSnackbarAction(
              "Password reset information have been sent on you registered email id",
              "success"
            )
          );
          history.push("/");
        }
      } catch (error) {
        console.log("reset error", error);
      }
    } else {
      dispatcher(showSnackbarAction("Please Enter Your Email!", "error"));
    }
  }

  const choice = () => {
    let optionArr = statesList?.map((list: { state_code: any, name: any }) => ({
      value: list.state_code,
      label: list.name
    }));
    return optionArr;
  };

  const countryChoice = () => {
    let optionArr = countryList?.map((list: { iso3: any, name: any, phone_code: any }) => ({
      value: list.iso3,
      label: `${list.name}`
      // label: `+${list.phone_code} ${list.name}`
    }));
    return optionArr;
  };

  const citiesChoice = () => {
    let optionArr = citiesList?.map((list: { name: any }) => ({
      value: list.name,
      label: list.name
    }));
    return optionArr;
  };

  const choiceIndustry = () => {
    let optionArr = industryList?.map((list: { industry_id: any, industry_name: any }) => ({
      value: list.industry_id,
      label: list.industry_name
    }));
    return optionArr;
  }

  const handleCountryChange = (event: { target: { value: any; }; }) => {
    setCountry(JSON.parse(event.target.value));
  };

  const handleStateChange = (event: { target: { value: any; }; }) => {
    setState(JSON.parse(event.target.value));
  };

  const handleCitiesChange = (event: { target: { value: any; }; }) => {
    setCities(JSON.parse(event.target.value));
  };

  const handleChange = (event: { target: { name: any; value: any; }; }) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value: string, country: CountryData) => {
    // Extract the country code and phone number from the input value
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setFinalPhoneNumber(value);
    }
    setPhoneCountryCode(country?.dialCode);
    setPhoneNumber(value)
  };

  useEffect(() => {
    getIndustry();
  }, []);

  const getIndustry = async () => {
    const industryRes = await axios.post(
      url + '/headers/getAllIndustries',
      {
        "status": "Launched"
      }
    );
    setIndustryList(industryRes.data);
  }

  const handleIndustryChange = (event: { target: { value: any; }; }) => {
    setIndustry(JSON.parse(event.target.value));
  };

  const adminHandlePhoneChange = (value: string, country: CountryData) => {
    // Extract the country code and phone number from the input value
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setAdminFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setAdminFinalPhoneNumber(value);
    }
    setAdminPhoneCountryCode(country?.dialCode);
    setAdminPhoneNumber(value)
  };

  const handleSubmit = (event: { preventDefault: () => void; }) => {
    event.preventDefault();
    // You can handle form submission here (e.g., send data to the server)
    const numberPattern = /^[0-9]+$/;
    if (formData.organizationName === "") {
      dispatcher(
        showSnackbarAction(
          "Organization Name Required!!",
          "error"
        )
      );
      return;
    }
    else if (formData.numberOfEmployees === "") {
      dispatcher(
        showSnackbarAction(
          "No of Employees Required!!",
          "error"
        )
      );
      return;
    }
    else if (formData.email === "") {
      dispatcher(
        showSnackbarAction(
          "Email Required!!",
          "error"
        )
      );
      return;
    }
    else if (formData.orgAddress === "") {
      dispatcher(
        showSnackbarAction(
          "Address Required!!",
          "error"
        )
      );
      return;
    }
    else if (Object.keys(country).length === 0) {
      dispatcher(
        showSnackbarAction(
          "Country Required!!",
          "error"
        )
      );
      return;
    }
    else if (Object.keys(state).length === 0) {
      dispatcher(
        showSnackbarAction(
          "State Required!!",
          "error"
        )
      );
      return;
    }
    else if (Object.keys(cities).length === 0) {
      dispatcher(
        showSnackbarAction(
          "City Required!!",
          "error"
        )
      );
      return;
    }
    else if (Object.keys(industry).length === 0) {
      dispatcher(
        showSnackbarAction(
          "Industry Id Required!!",
          "error"
        )
      );
      return;
    }
    else if (finalPhoneNumber === "") {
      dispatcher(
        showSnackbarAction(
          "Mobile Number Required!!",
          "error"
        )
      );
      return;
    }
    else if (formData.pincode === "") {
      dispatcher(
        showSnackbarAction(
          "Pincode Required!!",
          "error"
        )
      );
      return;
    }
    else if (formData.adminFirstName === "") {
      dispatcher(
        showSnackbarAction(
          "Admin First Name Required!!",
          "error"
        )
      );
      return;
    }
    else if (formData.adminLastName === "") {
      dispatcher(
        showSnackbarAction(
          "Admin First Last Required!!",
          "error"
        )
      );
      return;
    }
    else if (adminFinalPhoneNumber === "") {
      dispatcher(
        showSnackbarAction(
          "Admin Mobile Number Required!!",
          "error"
        )
      );
      return;
    }
    else if (formData.adminEmail === "") {
      dispatcher(
        showSnackbarAction(
          "Admin Email Required!!",
          "error"
        )
      );
      return;
    }
    setLoad(true);
    createOrganization(
      formData.organizationName,
      finalPhoneNumber,
      phoneCountryCode == "in" ? 91 : parseInt(phoneCountryCode),
      formData.email,
      formData.orgAddress,
      (country as any).label,
      (country as any).value,
      (state as any).label,
      (state as any).value,
      (cities as any).label,
      (cities as any).value,
      parseInt(formData.pincode),
      formData.adminFirstName,
      formData.adminLastName,
      adminFinalPhoneNumber,
      adminPhoneCountryCode == "in" ? 91 : parseInt(adminPhoneCountryCode),
      formData.adminEmail,
      parseInt(formData.numberOfEmployees),
      history,
      dispatcher,
      window,
      (data: boolean) => setLoad(data),
      (data: boolean) => setBooleanSendEmail(data),
      (data: any) => setPwd(data),
      (industry as any).value,
      (data: any) => setOrgId(data),
      (data: any) => setAuthId(data),
      cost,
      noEmp
    );
  };

  return (
    <Container maxWidth={false} className={classes.root}>
      <Grid container style={{ minHeight: '100vh' }}>
        {/* Left: Registration Form */}
        <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Paper elevation={0} className={classes.formContainer}>
            <Grid container direction="column" alignItems="center" spacing={2}>
              <Grid item>
                <Typography variant="h5" align="center"
                  style={{
                    fontFamily: "var(--font-family-main)",
                    fontWeight: 700,
                    fontSize: "var(--font-size-large)",
                    margin: 0,
                    marginBottom: 8,
                    color: "#292744",
                    textAlign: "center",
                  }}
                >
                  Create an account
                </Typography>
              </Grid>
            </Grid>
            <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Organization Name"
                    fullWidth
                    name="organizationName"
                    value={formData.organizationName}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                    InputProps={{ style: { color: '#222', fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Number of License User"
                    fullWidth
                    name="numberOfEmployees"
                    value={formData.numberOfEmployees}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                    InputProps={{ style: { color: '#222', fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Email Id"
                    type="email"
                    fullWidth
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                    InputProps={{ style: { color: '#222', fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Enter Address"
                    fullWidth
                    name="orgAddress"
                    value={formData.orgAddress}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                    InputProps={{ style: { color: '#222', fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomFormControl variant="outlined" required>
                    <InputLabel style={{ color: '#555', fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}>Country</InputLabel>
                    <Select
                      label="Country"
                      name="country"
                      value={country && Object.keys(country).length ? JSON.stringify(country) : ''}
                      onChange={handleCountryChange}
                      labelId="country-label"
                      renderValue={selected => {
                        if (!selected) return 'Country (Select one)';
                        try {
                          return JSON.parse(selected).label;
                        } catch {
                          return 'Country (Select one)';
                        }
                      }}
                      style={{ fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}
                    >
                      <MenuItem value="">Country (Select one)</MenuItem>
                      {countryChoice().map((country, index) => (
                        <MenuItem key={index} value={JSON.stringify(country)} style={{ fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}>{country.label}</MenuItem>
                      ))}
                    </Select>
                  </CustomFormControl>
                </Grid>
                <Grid item xs={6}>
                  <CustomFormControl variant="outlined" required>
                    <InputLabel style={{ color: '#555', fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}>State</InputLabel>
                    <Select
                      label="State"
                      name="state"
                      value={state && Object.keys(state).length ? JSON.stringify(state) : ''}
                      onChange={handleStateChange}
                      labelId="state-label"
                      renderValue={selected => {
                        if (!selected) return 'State (Select one)';
                        try {
                          return JSON.parse(selected).label;
                        } catch {
                          return 'State (Select one)';
                        }
                      }}
                      style={{ fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}
                    >
                      <MenuItem value="">State (Select one)</MenuItem>
                      {choice().map((state, index) => (
                        <MenuItem key={index} value={JSON.stringify(state)} style={{ fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}>{state.label}</MenuItem>
                      ))}
                    </Select>
                  </CustomFormControl>
                </Grid>
                <Grid item xs={6}>
                  <CustomFormControl variant="outlined" required>
                    <InputLabel style={{ color: '#555', fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}>City</InputLabel>
                    <Select
                      label="City"
                      name="city"
                      value={cities && Object.keys(cities).length ? JSON.stringify(cities) : ''}
                      onChange={handleCitiesChange}
                      labelId="city-label"
                      renderValue={selected => {
                        if (!selected) return 'City (Select one)';
                        try {
                          return JSON.parse(selected).label;
                        } catch {
                          return 'City (Select one)';
                        }
                      }}
                      style={{ fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}
                    >
                      <MenuItem value="">City (Select one)</MenuItem>
                      {citiesChoice().map((city, index) => (
                        <MenuItem key={index} value={JSON.stringify(city)} style={{ fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}>{city.label}</MenuItem>
                      ))}
                    </Select>
                  </CustomFormControl>
                </Grid>
                <Grid item xs={6}>
                  <CustomFormControl variant="outlined" required>
                    <InputLabel style={{ color: '#555', fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}>Industry</InputLabel>
                    <Select
                      label="Industry"
                      name="industry"
                      value={industry && Object.keys(industry).length ? JSON.stringify(industry) : ''}
                      onChange={handleIndustryChange}
                      labelId="industry-label"
                      renderValue={selected => {
                        if (!selected) return 'Industry (Select one)';
                        try {
                          return JSON.parse(selected).label;
                        } catch {
                          return 'Industry (Select one)';
                        }
                      }}
                      style={{ fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}
                    >
                      <MenuItem value="">Industry (Select one)</MenuItem>
                      {choiceIndustry().map((industry, index) => (
                        <MenuItem key={index} value={JSON.stringify(industry)} style={{ fontFamily: 'var(--font-family-main)', fontSize: 'var(--font-size-medium)' }}>{industry.label}</MenuItem>
                      ))}
                    </Select>
                  </CustomFormControl>
                </Grid>
                <Grid item xs={6}>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <label style={{
                      position: 'absolute',
                      top: '-9px',
                      left: '11px',
                      background: '#f7f8fa',
                      padding: '0 4px',
                      fontSize: '12px',
                      color: '#555',
                      fontFamily: 'var(--font-family-main)',
                      zIndex: 2
                    }}>
                      Mobile Number *
                    </label>
                    <PhoneInputWrapper>
                      <PhoneInput
                        country={phoneCountryCode || 'in'}
                        value={phoneNumber || ''}
                        onChange={handlePhoneChange}
                        placeholder="Mobile Number"
                        inputProps={{ type: 'tel', autoComplete: 'tel', name: 'phone', style: { fontFamily: 'var(--font-family-main)' } }}
                        inputStyle={{
                          background: '#f9fafb',
                          width: '100%',
                          fontSize: 'var(--font-size-medium)',
                          fontFamily: 'var(--font-family-main)',
                          color: '#222',
                          padding: '0 14px 0 48px',
                          borderRadius: 12,
                          boxSizing: 'border-box',
                          height: '48px',
                          lineHeight: '48px',
                        }}
                        containerStyle={{
                          height: '48px',
                          borderRadius: 12,
                          background: '#f9fafb',
                          border: 'none',
                          boxSizing: 'border-box',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: 'var(--font-size-medium)',
                          fontFamily: 'var(--font-family-main)',
                        }}
                        buttonStyle={{ border: 'none', background: 'transparent' }}
                        dropdownStyle={{ borderRadius: 12 }}
                        disableDropdown={false}
                        enableSearch={true}
                        masks={{ in: '..........' }}
                      />
                    </PhoneInputWrapper>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Enter Pincode"
                    fullWidth
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    InputLabelProps={{
                      style: {
                        color: "#555", fontSize: 'var(--font-size-medium)',
                        fontFamily: 'var(--font-family-main)'
                      }
                    }}
                    InputProps={{
                      style: {
                        color: '#222', fontSize: 'var(--font-size-medium)',
                        fontFamily: 'var(--font-family-main)'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Admin First Name"
                    fullWidth
                    name="adminFirstName"
                    value={formData.adminFirstName}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    InputLabelProps={{
                      style: {
                        color: "#555", fontSize: 'var(--font-size-medium)',
                        fontFamily: 'var(--font-family-main)'
                      }
                    }}
                    InputProps={{
                      style: {
                        color: '#222', fontSize: 'var(--font-size-medium)',
                        fontFamily: 'var(--font-family-main)'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Admin Last Name"
                    fullWidth
                    name="adminLastName"
                    value={formData.adminLastName}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    InputLabelProps={{
                      style: {
                        color: "#555", fontSize: 'var(--font-size-medium)',
                        fontFamily: 'var(--font-family-main)'
                      }
                    }}
                    InputProps={{
                      style: {
                        color: '#222', fontSize: 'var(--font-size-medium)',
                        fontFamily: 'var(--font-family-main)'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Admin Email Id"
                    type="email"
                    fullWidth
                    name="adminEmail"
                    value={formData.adminEmail}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    InputLabelProps={{
                      style: {
                        color: "#555", fontSize: 'var(--font-size-medium)',
                        fontFamily: 'var(--font-family-main)'
                      }
                    }}
                    InputProps={{
                      style: {
                        color: '#222', fontSize: 'var(--font-size-medium)',
                        fontFamily: 'var(--font-family-main)'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <label style={{
                      position: 'absolute',
                      top: '-9px',
                      left: '12px',
                      background: '#f7f8fa',
                      padding: '0 4px',
                      fontSize: '11px',
                      color: '#555',
                      fontFamily: 'var(--font-family-main)',
                      zIndex: 2
                    }}>
                      Admin Mobile Number *
                    </label>
                    <PhoneInputWrapper>
                      <PhoneInput
                        country={adminPhoneCountryCode || 'in'}
                        value={adminPhoneNumber || ''}
                        onChange={adminHandlePhoneChange}
                        placeholder="Mobile Number"
                        inputProps={{ type: 'tel', autoComplete: 'tel', name: 'adminPhone', style: { fontFamily: 'var(--font-family-main)' } }}
                        inputStyle={{
                          background: '#f9fafb',
                          width: '100%',
                          fontSize: 'var(--font-size-medium)',
                          fontFamily: 'var(--font-family-main)',
                          color: '#222',
                          padding: '0 14px 0 48px',
                          borderRadius: 12,
                          boxSizing: 'border-box',
                          height: '48px',
                          lineHeight: '48px',
                        }}
                        containerStyle={{
                          height: '48px',
                          borderRadius: 12,
                          background: '#f9fafb',
                          border: 'none',
                          boxSizing: 'border-box',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: 'var(--font-size-medium)',
                          fontFamily: 'var(--font-family-main)'
                        }}
                        buttonStyle={{ border: 'none', background: 'transparent' }}
                        dropdownStyle={{ borderRadius: 12 }}
                        disableDropdown={false}
                        enableSearch={true}
                        masks={{ in: '..........' }}
                      />
                    </PhoneInputWrapper>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <button
                    style={{
                      width: "100%",
                      background: "linear-gradient(90deg, #292744 0%, #292744 100%)",
                      color: "#fff",
                      border: "none",
                      borderRadius: 10,
                      padding: "14px 0",
                      fontSize: "var(--font-size-large)",
                      marginTop: 12,
                      cursor: "pointer",
                      boxShadow: "0 2px 8px rgba(41,39,68,0.10)",
                      fontFamily: "var(--font-family-main)",
                      transition: "background 0.2s, box-shadow 0.2s",
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onMouseOver={e => e.currentTarget.style.background = "linear-gradient(90deg, #292744 0%, #292744 100%)"}
                    onMouseOut={e => e.currentTarget.style.background = "linear-gradient(90deg, #292744 0%, #292744 100%)"}
                    type="submit"
                  >
                    {load ? (
                      <span style={{ display: "flex", justifyContent: "center" }}>
                        <Circles color="#fff" height={20} width={20} />
                      </span>
                    ) : (
                      <>
                        <BusinessIcon style={{ marginRight: 8 }} /> Register
                      </>
                    )}
                  </button>
                </Grid>
                <Grid item xs={12} style={{
                  marginBottom: 0,
                  fontSize: "var(--font-size-medium)",
                  color: "#555",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  whiteSpace: "nowrap",
                  fontFamily: "var(--font-family-main)"
                }}>
                  Already have an account?
                  <span style={{
                    color: "#292744",
                    cursor: "pointer",
                    marginLeft: 4,
                    fontWeight: 500,
                    textDecoration: "underline"
                  }} onClick={() => history.push("/")}>Login now</span>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
        {/* Right: Testimonial */}
        <Grid item xs={12} md={6} className={classes.testimonialSection}>
          <div>
            <div className={classes.quoteText}>
              You can't just ask customers what they want and then try to give that to them. By the time you get it built, they'll want something new.
            </div>
            <div className={classes.testimonialUser}>
              <Avatar
                src={SteveJobsImages}
                className={classes.testimonialAvatar}
              />
              <div>
                <div className={classes.testimonialName}>Steve Jobs</div>
                <div className={classes.testimonialRole}>Apple Co-founder</div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};
export default RegistrationForm;
